var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PrimaryLayout',[_c('div',{staticClass:"section mb-4"},[_c('div',{staticClass:"autospacing w-container"},[_c('div',[_vm._v(" File not found! ")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v(" -> Go Home")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }